export default {
  avatar (state) {
    return `${state.entity.name[0]}${state.entity.lastName[0]}`
  },

  fullName (state) {
    return `${state.entity.name} ${state.entity.lastName}`
  }
}